import React from "react";
import "./../../styles/components/Solutions.css";
import CurrentTheme from "./../CurrentTheme";

export default function SolutionsIT() {
  return (
    <div className="solutions">
      <div className="bens-container">
        <div className="solutions-top">
          <div className="box-col">
            <div className="media-group has-one">
              <a
                className="media-item"
                href="https://bens-digital-change.com/achat-et-vente-a-linternational"
                target="_blank"
                rel="noopener noreferrer"
              >
                <h4>Acquisto / vendita internazionale</h4>
                <img
                  src="/img/sol-04.webp"
                  alt="Sol 04"
                  loading="lazy"
                  width={351}
                  height={363}
                />
              </a>

              <a
                className="media-item"
                href="https://bens-digital-change.com/payez-vos-fournisseurs"
                target="_blank"
                rel="noopener noreferrer"
              >
                <h4>Pagamento del fornitore</h4>
                <img
                  src="/img/sol-03.webp"
                  alt="Sol 03"
                  loading="lazy"
                  width={358}
                  height={351}
                />
              </a>
            </div>
          </div>
          <div className="box-col solutions-top-right">
            <h2>
              La soluzione di scambio adattata alle tue esigenze professionali
            </h2>
            <a
              href="https://bens-digital-change.swiss/register"
              target="_blank"
              rel="noopener noreferrer"
            >
              Iscrizione gratuita e non vincolante
            </a>
            <a
              href="https://calendly.com/bens_digital/demande-d-assistance"
              target="_blank"
              rel="noopener noreferrer"
            >
              Contatta i nostri consulenti
            </a>
          </div>
        </div>

        <div className="section-08-box solutions-bottom">
          <div className="box-col">
            <img
              src="https://bens-digital-change.com/images/v2/get-mobile-back.webp"
              alt="Get Mobile"
              className="box-img"
              loading="lazy"
              width={733}
              height={671}
            />
          </div>
          <div className="box-col">
            <h2 className="box-title">
              La nostra soluzione è disponibile sul cellulare
            </h2>
            <img
              src="/img/bens-title-dark.svg"
              alt="Bens"
              className="box-desc-img"
              loading="lazy"
              width={399}
              height={51}
            />
            <p className="box-long-desc">
              Effettua tutte le tue transazioni in valuta estera sulla nostra
              applicazione disponibile su Android e IOS. Vuoi cambiare la tua
              valuta in un momento specifico?
            </p>
            <p className="box-long-desc">
              La nostra applicazione ti offre la possibilità di creare un avviso
              per avvisarti quando il tasso di cambio raggiunge quello da te Che
              volete.
            </p>
            <a
              href="https://bens-digital-change.ch/download-mobile-app"
              className="box-store"
              target="_blank"
              rel="noopener noreferrer"
            >
              <img
                src="https://bens-digital-change.com/images/v2/bens-stores.webp"
                alt="Bens Store"
                loading="lazy"
              />
            </a>
          </div>
        </div>
      </div>
      <div
        className="solutions-back"
        style={{
          background:
            "linear-gradient(180deg, " +
            CurrentTheme(process.env.REACT_APP_THEME)["color"][0] +
            " 0%, " +
            CurrentTheme(process.env.REACT_APP_THEME)["color"][1] +
            " 100%)",
        }}
      ></div>
    </div>
  );
}
